import { createSelector } from '@ngrx/store';
import { cartState } from '../root';

export const getCartMenuFlows = createSelector(cartState, (cart) => cart.itemsMenuFlow);
